import yup from 'utils/yup';

export const initialTrackMileageModal = {
  trackMileage: '' as any,
};

export const trackMileageValidationSchema = yup.object().shape({
  trackMileage: yup.string().required(),
});
